import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { VoiceClient } from 'modules/ai_voice/components/VoiceClient'

import './index.css'

// All this is provisional. It will go away when we move the voice agent client inside the chat.
function parseVoiceAgentParam(value: string | null): { agent: string; task: string } | null {
  if (value == null || value === '') return null
  const firstDash = value.indexOf('-')
  if (firstDash === -1) {
    return { agent: value, task: '' }
  }
  return {
    agent: value.slice(0, firstDash),
    task: value.slice(firstDash + 1).replace(/-/g, '_'),
  }
}

export function FactorialVoiceAgent() {
  // TODO: implement showing the voice agent with a feature flag
  const [searchParams] = useSearchParams()
  const paramValue = searchParams.get('voice-agent')
  const [parsed, setParsed] = useState<{ agent: string; task: string } | null>(null)

  useEffect(() => {
    const next = parseVoiceAgentParam(paramValue)
    if (next) setParsed((prev) => prev ?? next)
  }, [paramValue])

  if (!parsed) return null

  return (
    <div className="factorial-voice-agent-popup">
      <VoiceClient agent={parsed.agent} task={parsed.task} />
    </div>
  )
}
